import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { FacebookCommentsInterface } from 'common/types/entities/FacebookCommentsInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createFacebookComments = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): FacebookCommentsInterface => {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.FacebookComments,
      parentId,
      masterBlockId,
    ),
    delay: 0,
    href: '',
    numPosts: 5,
  }
}
